import React from "react";
import { X } from "lucide-react";
import UrgentBadge from "./UrgentBadge";
import StatusBadge from "./StatusBadge";
import ECGImageViewer from "./ECGImageViewer";

function Field({ label, value }) {
  return (
    <div>
      <p className="text-xs text-[#6B7280]">{label}</p>
      <p className="text-sm font-medium text-[#1F2937] mt-0.5">
        {value === null || value === undefined || value === "" ? "—" : String(value)}
      </p>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div className="border border-[#E5E7EB] rounded-lg p-4">
      <h4 className="text-sm font-semibold text-[#1F2937] mb-3">{title}</h4>
      <div className="grid grid-cols-2 gap-4">{children}</div>
    </div>
  );
}

export default function ECGCaseDetails({ patient, onClose }) {
  if (!patient) return null;

  return (
    <div
      className="fixed inset-0 z-40 bg-black/40 flex items-start sm:items-center justify-center p-3 sm:p-6 overflow-y-auto"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-xl shadow-xl w-full max-w-3xl my-6"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-5 py-4 border-b border-[#E5E7EB]">
          <div className="flex items-center gap-2">
            <h3 className="text-base font-semibold text-[#1F2937]">
              {patient.PatientName || "Patient"}
            </h3>
            {patient.urgent ? <UrgentBadge size="sm" /> : null}
          </div>
          <button
            onClick={onClose}
            className="text-[#6B7280] hover:text-[#1F2937] p-1"
            aria-label="Close details"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-5 space-y-4 max-h-[75vh] overflow-y-auto">
          <Section title="Patient Information">
            <Field label="Patient Name" value={patient.PatientName} />
            <Field label="Patient ID" value={patient.PatientId} />
            <Field label="Age" value={patient.age} />
            <Field label="Gender" value={patient.gender} />
            <Field label="Customer" value={patient.customer?.name} />
          </Section>

          <Section title="ECG Information">
            <Field label="Heart Rate" value={patient.HeartRate} />
            <Field label="PR Interval" value={patient.PRInterval} />
            <Field label="Test Date" value={patient.TestDate} />
            <Field label="Report Date" value={patient.ReportDate} />
          </Section>

          <Section title="Case Information">
            <Field label="Status" value={patient.status ? "Reported" : "Pending"} />
            <Field label="Urgent" value={patient.urgent ? "Yes" : "No"} />
            <Field label="Non Reportable" value={patient.NonReportable ? "Yes" : "No"} />
            <Field label="Remarks" value={patient.remarks} />
            <Field label="Uploaded At" value={patient.uploaded_at} />
          </Section>

          <Section title="References">
            <Field label="U4RAD Reference ID" value={patient.u4rad_reference_id} />
            <Field label="Vendor Reference ID" value={patient.vendor_reference_id} />
          </Section>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <h4 className="text-sm font-semibold text-[#1F2937] mb-2">ECG Image</h4>
              <ECGImageViewer src={patient.Image} label="ECG" />
            </div>
            {/* <div>
              <h4 className="text-sm font-semibold text-[#1F2937] mb-2">Report</h4>
              <ECGImageViewer src={patient.reportimage} label="Report" />
            </div> */}
          </div>

          <div className="flex justify-end pt-2">
            <StatusBadge status={patient.status} />
          </div>
        </div>
      </div>
    </div>
  );
}
